import { useEffect } from "react";
import {
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useParams,
} from "react-router";
import { AnimatedPageRoutes } from "./AnimatedPageRoutes";
import TopHeader from "@/components/TopHeader";
import BottomNav from "@/components/BottomNav";
import { KLineBackdrop } from "@/components/KLineBackdrop";
import { saveInviteCode } from "@/lib/invite";
import { cn } from "@/lib/utils";
import { routes } from "./routes";
import { SetPasswordEnforcer } from "@/components/login/SetPasswordEnforcer";

// ---------- 邀请码 ----------
function InviteCodeHandler() {
  const { code } = useParams<{ code: string }>();
  useEffect(() => {
    if (code) saveInviteCode(code);
  }, [code]);
  return <Navigate to="/ai-trading" replace />;
}

// ---------- 布局壳 ----------
function AppLayout() {
  const { pathname } = useLocation();
  const hit = routes.find(r => r.path === pathname);
  const showHeader = hit?.meta.showHeader ?? true;
  const showBottomNav = hit?.meta.showBottomNav ?? true;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen bg-background flex flex-col relative">
      <SetPasswordEnforcer />
      {showHeader && <TopHeader />}
      <main
        className={cn(
          "flex-1 relative z-10 overflow-x-hidden",
          showBottomNav && "pb-20"
        )}
      >
        {/* 顶部 K 线条带：随页面滚动上移、上下有边界 */}
        <KLineBackdrop />
        <div className="relative z-10">
          <Outlet />
        </div>
      </main>
      {showBottomNav && <BottomNav />}
    </div>
  );
}

// ---------- 路由入口 ----------
export function AppRouter() {
  return (
    <Routes>
      <Route path="/ic/:code" element={<InviteCodeHandler />} />

      <Route element={<AppLayout />}>
        <Route path="/*" element={<AnimatedPageRoutes />} />
      </Route>
    </Routes>
  );
}

export { routes, type RouteMeta } from "./routes";
